/* eslint-disable camelcase */
import React, { useCallback } from 'react';
import { Form } from 'formik';
import { Col, Row } from 'reactstrap';
import LoadingButton from 'components/common/LoadingButton';
import CardWithTitle from 'components/CardWithTitle';
import EditUploadWrapper from 'components/EditUploadWrapper';
import S3FileUploadField from 'components/S3FileUploadField';

const UserVerificationDocumentForm = (props) => {
  const { handleSubmit, isSubmitting, isValid, dirty, values, setFieldValue } =
    props;

  const handleCancel = useCallback(
    (val) => {
      setFieldValue(val, '');
    },
    [setFieldValue],
  );

  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle>
        <Row>
          <Col>
            {values?.USER_VERIFICATION_DOCUMENT?.length ? (
              <EditUploadWrapper
                label="Verification Document"
                fileName={values.USER_VERIFICATION_DOCUMENT}
                name="USER_VERIFICATION_DOCUMENT"
                handleCancel={() => handleCancel('USER_VERIFICATION_DOCUMENT')}
                accept=".pdf"
                required
              />
            ) : (
              <S3FileUploadField
                label="Verification Document"
                name="USER_VERIFICATION_DOCUMENT"
                pathUrl="images/ui_settings/user_verification_document"
                accept=".pdf"
                required
              />
            )}
          </Col>
        </Row>
      </CardWithTitle>
      <div className="form-btn d-flex justify-content-end mt-4">
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting}
          color="warning"
          size="sm"
          type="submit"
        >
          Upload
        </LoadingButton>
      </div>
    </Form>
  );
};

export default UserVerificationDocumentForm;
